import ToggleRowStyle from './Common';
import { useEffect, useState } from 'react';
import { supabaseClient } from './supabase';
import {
  Datagrid,
  EditButton,
  DeleteButton,
  List,
  Pagination,
  TextField,
  ReferenceField,
  Filter,
  SearchInput,
  useGetIdentity,
  useRecordContext,
  useGetList,
  SavedQueriesList,
  FilterLiveSearch,
  FilterList,
  Loading,
  FilterListItem,
  SelectArrayInput,
  SelectInput,
  DateField,
  useListContext,
  RichTextField,
  required,
  CreateButton,
  TopToolbar,
} from 'react-admin';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import CategoryIcon from '@mui/icons-material/LocalOffer';

import { useSearchParams } from 'react-router-dom';

const ListActions = () => {
    return (
        <TopToolbar>
            <CreateButton to={`/loerieleersentrum/create`} />
        </TopToolbar>
    );
};


const MyEmpty = () => (
    <Box textAlign="center" m={10}>
        <Typography variant="h4" paragraph>
            No Items available
        </Typography>
        <Typography variant="body1">
            Create a new Item
        </Typography>
        <CreateButton to={`/loerieleersentrum/create`} />
    </Box>
);

const LoerieleersentrumFilterSidebar = (props) => {
  const {
    subjectsData: data,
    studentData,
    identity,
  } = props;
  const {
    isLoading: listLoading,
    error: listError,
    filterValues,
  } = useListContext();

  console.log(`List Context filtervalues: ${JSON.stringify(filterValues)}`);
  const filterList = filterValues.grade ? [filterValues.grade] : null;
  console.log(`filterList: ${JSON.stringify(filterList)}`);
  const gradesList = filterList
    ? filterList
    : studentData
        .map((student) => student.classes.grade)
        .filter(function (el, idx, self) {
          return idx === self.indexOf(el);
        });
  console.log(`gradesList: ${JSON.stringify(gradesList)}`);

  return (
    <Card sx={{ order: -1, mr: 2, mt: 8, width: 380 }}>
      <CardContent>
        <FilterList label="Subjects" icon={<CategoryIcon />}>
          {data.map((record) => {
            return (
              (record.grades.some((r) => gradesList.includes(r)) && (
                <FilterListItem
                  sx={{ borderLeft: `10px solid ${record.color}`, margin: 1 }}
                  label={record.subject}
                  value={{ subject_id: record.id }}
                  key={record.id}
                />
              )) ||
              ''
            );
          })}
        </FilterList>
      </CardContent>
    </Card>
  );
};

const LoerieleersentrumFilters = (props) => {
  const { subjectsData, studentData, identity } = props;
  const [searchParams] = useSearchParams();
  const selectedSubject = JSON.parse(searchParams.get('filter'))?.subject_id;
  console.log(`selectedSubject: ${selectedSubject}`);
  const subjectsMap = {};
  for (const subject of subjectsData) {
    subjectsMap[subject.id] = subject.grades;
  }
  console.log(`subjectsMap: ${JSON.stringify(subjectsMap)}`);
  if (selectedSubject)
    console.log(
      `selectedMap[selectSubject]: ${JSON.stringify(
        subjectsMap[selectedSubject]
      )}`
    );
  const learners = studentData.map(
    (student) =>
      (!selectedSubject ||
        subjectsMap[selectedSubject].includes(student.classes.grade)) && {
        id: student.classes.grade,
        name: `${student.first_name} ${student.last_name} - ${student.classes.class_code}`,
      }
  );
  const gradesList = studentData
    .map((student) => student.classes.grade)
    .filter(function (el, idx, self) {
      return idx === self.indexOf(el);
    });
  const grades = gradesList.sort().map((grade) => ({
    id: grade,
    name: `Grade ${grade}`,
  }));

  return (
    <Filter {...props}>
      <SearchInput placeholder="Search title" source="title@ilike" alwaysOn />
      {identity.role === 'parent' && (
        <SelectInput
          label="Children"
          source="grade"
          validate={required()}
          choices={learners}
          alwaysOn
        />
      )}
      {['admin', 'teacher'].includes(identity.role) && (
        <SelectInput
          label="Grade"
          source="grade"
          emptyText={`All`}
          choices={grades}
          alwaysOn
        />
      )}
    </Filter>
  );
};

function LoerieleersentrumList(props) {
  // Only fetch subjects with remedial = true
  const {
    data: subjectsData,
    isLoading: isSubjectsLoading,
    error: subjectsError,
  } = useGetList('subjects', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'subject', order: 'ASC' },
    filter: { remedial: true },
  });
  const [studentData, setStudentData] = useState(false);
  const {
    data: identity,
    isLoading: isIdentityLoading,
    error: identityError,
  } = useGetIdentity();

  useEffect(() => {
    if (identity !== null) {
      getStudents(identity);
    }
  }, [identity]);

  const getStudents = async (identity) => {
    let options = {};
    if (identity) {
      switch (identity.role) {
        case 'parent':
          options = {
            household_hash: `${identity.household_hash}`,
          };
          break;
        case 'teacher':
          if (identity.class_id !== null) {
            options = {
              class_id: identity.class_id,
            };
          } else {
            options = {
              grade: identity.grade,
            };
          }
          break;
        default:
          break;
      }
      const { data, error } = await supabaseClient
        .from('students')
        .select(
          `
          id,
          first_name,
          last_name,
          class_id,
          household_hash,
          classes (
            id,
            class_code,
            grade
          )
        `
        )
        .match(options);
      if (error)
        throw new Error(`Error fetching the students: ${error.message}`);
      console.log(`studentData: ${JSON.stringify(data)}`);
      setStudentData(data);
    }
  };

  if (isIdentityLoading || isSubjectsLoading) return <>Loading....</>;
  if (identityError || subjectsError) return <>Error...</>;

  return (
    studentData && (
      <List
        {...props}
        empty={<MyEmpty/>}
        actions={<ListActions/>}
        resource="lessons"
        aside={
          <LoerieleersentrumFilterSidebar
            subjectsData={subjectsData}
            studentData={studentData}
            identity={identity}
          />
        }
        filters={
          <LoerieleersentrumFilters
            subjectsData={subjectsData}
            studentData={studentData}
            identity={identity}
          />
        }
        filter={{ remedial: true }}
        filterDefaultValues={
          identity.role === 'parent'
            ? { grade: studentData[0]?.classes.grade }
            : {}
        }
        title="Loerieleersentrum"
        sx={{
          '& .RaDatagrid-table tr td:last-child': {
            maxWidth: '40%',
            width: '20%',
          },
        }}
      >
        <Pagination />
        <Datagrid
          rowStyle={ToggleRowStyle}
          bulkActionButtons={false}
          key={(record) => `${record.id}`}
          rowClick={['parent'].includes(identity.role) ? 'show' : false}
        >
          <RichTextField source="title" />
          <ReferenceField
            source="term_id"
            reference="terms"
            emptyText="TERM NOT SELECTED!"
          >
            <TextField source="name" />
          </ReferenceField>
          <RichTextField source="term_week" label="Week" />
          {['admin', 'teacher'].includes(identity.role) ? (
            <ReferenceField
              source="subject_id"
              reference="subjects"
              emptyText="SUBJECT NOT LINKED!"
            />
          ) : null}
          {['admin', 'teacher'].includes(identity.role) ? (
            <TextField source="grade" />
          ) : null}
          {['admin', 'teacher'].includes(identity.role) ? (
            <>
              <EditButton />
              <DeleteButton mutationMode="pessimistic" redirect="/loerieleersentrum" />
            </>
          ) : null}
        </Datagrid>
      </List>
    )
  );
}

export default LoerieleersentrumList;
